module.exports = __webpack_public_path__ + "02796bef5bf42f89edf80fd268f77395.svg";